import React, { useContext, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { bucketManager, groupContext } from "../index.js";
import PlainEditor from "../../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import { DTConfigInGalleryContext } from "../../scripts/DTConfigInGalleryContext.js";
import { useContentDt } from "../../scripts/useContentDt.js";
import BucketManager from "../bucketManager/bucketManager.js";
import { OneTImeOfferBeforePaymentContainer } from "../oneTimeOfferBeforePaymentContainer/onetTimeOfferBeforePaymentContainer.js";
import OrderedImagesList from "../orderedImagesList/orderedImagesList.js";
import "./bucketContainer.css";
export default function BucketContainer(props) {
    var _a;
    const [params, setParams] = useSearchParams();
    const [updateRequest, setUpdateRequest] = useState(0);
    const [totalPrice, setTotalPrice] = useState(NaN);
    const [formPrice, setFormPrice] = useState(0);
    const [orders, setOrders] = useState([]);
    const [disposableItems, setDisposableItems] = useState([]);
    const [discounts, setDiscounts] = useState();
    const [priceWithoutDiscounts, setPriceWithoutDiscounts] = useState();
    const readonlyMode = useRef(false);
    const state = useRef(undefined);
    const id = useRef(undefined);
    const key = useRef(undefined);
    const [status, setStatus] = useState(200);
    const [paymentMethod, setPaymentMethod] = useState();
    const [dbFormResults, setDbFormResults] = useState();
    const [openPaymentChooser, setOpenPaymentChooser] = useState(false);
    const group = useContext(groupContext);
    useEffect(() => {
        if (params.has("openBasket")) {
            params.delete("openBasket");
            setParams(params);
            props.onSetOpen();
        }
    }, [params]);
    useEffect(() => {
        if (props.isOpen == false)
            return;
        bucketManager.Bucket.fetch().then((response) => {
            setStatus(response.status);
            if (response.status === 200) {
                readonlyMode.current = response.readonly;
                state.current = response.state;
                id.current = response.orderId;
                key.current = response.key;
                setOrders(response.images);
                setDisposableItems(response.disposableItems);
                setTotalPrice(response.totalPrice);
                setDiscounts(response.discounts);
                setPaymentMethod(response.paymentMethod);
                setPriceWithoutDiscounts(response.originalPriceWithoutDiscounts);
                setFormPrice(response.formInputsPrice);
                setDbFormResults(response.formInputs);
                return;
            }
            readonlyMode.current = false;
            state.current = undefined;
            id.current = undefined;
            key.current = undefined;
            setOrders([]);
            setDisposableItems([]);
            setTotalPrice(NaN);
            setDiscounts(undefined);
            setPriceWithoutDiscounts(undefined);
            setPaymentMethod(undefined);
            setFormPrice(0);
            setDbFormResults(undefined);
        });
    }, [props.isOpen, updateRequest]);
    //auto closing bucket
    window.onclick = (event) => {
        const target = event.target;
        if (!target.closest(".bucket-container") && !target.closest("button")) {
            props.closeBucket();
        }
    };
    const text = useContentDt((_a = group === null || group === void 0 ? void 0 : group.content) === null || _a === void 0 ? void 0 : _a.infoInBasket, DTConfigInGalleryContext);
    return (React.createElement(CSSTransition, { in: props.isOpen, timeout: 300, unmountOnExit: true, classNames: "bucket-container", onEntered: () => { }, onExited: () => { } },
        React.createElement("div", { className: "bucket-container", "data-payment-chooser": openPaymentChooser }, !openPaymentChooser ?
            React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("h3", null, "Koszyk"),
                    text !== undefined && (React.createElement(PlainEditor, { editable: false, example: text, label: "", onChange: () => { } }))),
                React.createElement(OrderedImagesList, { orders: orders, readonlyMode: readonlyMode.current, status: status, disposableItems: disposableItems, updateRequest: () => setUpdateRequest((old) => old + 1) }),
                React.createElement(BucketManager, { canSubmit: !(orders.length == 0 && disposableItems.length == 0), readonlyMode: readonlyMode.current, onOrderSubmitted: () => setOpenPaymentChooser(true), totalPrice: totalPrice, state: state.current, orderKey: key.current, orderId: id.current, discounts: discounts, paymentType: paymentMethod, priceWithoutDiscounts: priceWithoutDiscounts, onUpdate: () => setUpdateRequest((o) => o + 1) }))
            : React.createElement(OneTImeOfferBeforePaymentContainer, { totalPrice: totalPrice, dbFormResults: dbFormResults !== null && dbFormResults !== void 0 ? dbFormResults : {}, formInputsPrice: formPrice, orderedOffers: disposableItems, goBack: () => setOpenPaymentChooser(false), onUpdateBucket: () => setUpdateRequest((old) => old + 1) }))));
}
